export function generateGroupTypeLabel(groupType) {
  if (!groupType) {
    return '';
  }
  return groupType.label ? groupType.label : groupType.standard ? 'standard' : 'accommodated';
}

export function generateGroupTypeCellStr(group, student) {
  if (!group) {
    return `${student.groupType}`;
  }
  return group?.title
    ? `${student.groupType}: ${group?.title} (${generateGroupTypeLabel(group)})`
    : `${student.groupType}: ${generateGroupTypeLabel(group)}`;
}
